const MINOR_UNITS_PER_MAJOR = 100;

export const formatMinorUnits = (value, currency) => {
  const amount = Number(value || 0) / MINOR_UNITS_PER_MAJOR;
  const plain = amount.toFixed(2);
  if (!currency) return plain;
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency.toUpperCase(),
    }).format(amount);
  } catch (error) {
    return `${plain} ${currency.toUpperCase()}`;
  }
};
